import React from 'react';
import { loadable } from '@shared/core/loadableFromNamedExport';
import { GuestStaysDashboardSkeleton } from './GuestStaysDashboard.skeleton';

// The dashboard and today's booking tracker are mutually exclusive renders of the same tab, so only
// the one the flag selects should reach the browser.
export const LazyGuestStaysDashboard = loadable(() => import(/* webpackChunkName: "admin/accommodations/GuestStaysDashboard" */ './GuestStaysDashboard'), 'GuestStaysDashboard', {
  // Without this the tab renders nothing for the chunk's round-trip: the flag-loading skeleton has
  // already unmounted and the dashboard's own skeleton lives inside the chunk still downloading.
  // The skeleton is a separate module, so naming it here does not pull the dashboard chunk forward.
  fallback: <GuestStaysDashboardSkeleton />,
});
